export default {
	entgratart: {
		notEntgraten: "No deburring",
		manually: "Manual",
		oneSided: "One-sided (underside)",
		trowalisieren: "Tumbling",
		bothSides: "Both sides",
		undefinedState: "Undefined",
		notAvailable: "Not available",
	},
	priceModel: {
		standard: "Fast",
		slow: "Economical",
		express: "Express",
	},
	zincCoating: {
		none: "No",
		hotDip: "Hot-dip galvanised",
		galvanize: "Electro-galvanised",
		both: "Both",
	},
	complainType: {
		outOfTolerance: "Dimensions out of tolerance",
		wrongBending: "Incorrect bending",
		cutQualityLow: "Cut quality not satisfactory",
		scratches: "Surface excessively scratched",
		missingCuts: "Missing cut-outs",
		wrongGrainDirection: "Wrong grain direction",
		transportDamage: "Transport damage",
		missing: "Parts missing from delivery",
		powderCoating: "Powder coating defective",
		weldline: "Weld seam defective",
		feature: "Thread, countersink or dimple defective",
		other: "Other complaint",
		zincCoating: "Zinc coating defective",
		wrongOrMissingPressJoin: "Press joint missing or not as ordered",
	},
	complaintExpectationType: {
		ersatzlieferung: "Replacement delivery",
		other: "Other expectation...",
	},
};
